import type {
  BaseEvent,
  GeoPlugin,
  UserPlugin,
  ViewPlugin,
} from "@dndbeyond/event-pipeline-lib/shared";

import { getPlatform } from "../helpers/platform";
import type {
  CharacterActionInput,
  CharacterActionPlugin,
  CommonEventFields,
  EventContext,
} from "./types";

export const CHARACTER_ACTION_MESSAGE_NAME = "CHARACTER_ACTION";

export const getToolVersion = () =>
  `characters ${process.env.REACT_APP_VERSION ?? "unknown"}`;

export type BuildCharacterActionEventOptions = CharacterActionInput &
  CommonEventFields &
  EventContext & { characterId: number | null };

/**
 * CHARACTER_ACTION EVENT
 * Fires when a user changes their character in the builder
 * https://wizardsofthecoast.atlassian.net/wiki/x/HAAWN
 */
export const buildCharacterActionEvent = ({
  changeCategory,
  changeDescriptors,
  characterId,
  region,
  subscriptionLevel,
  ipAddress,
  userId,
  sessionId,
  visitorId,
  pageUrl,
  location,
}: BuildCharacterActionEventOptions): BaseEvent => {
  const userPlugin: UserPlugin = {
    userId,
    subscriptionLevel,
    sessionId,
    visitorId,
  };

  const geoPlugin: GeoPlugin = {
    region,
    ipAddress,
  };

  const viewPlugin: ViewPlugin = {
    current: pageUrl,
  };

  const characterActionPlugin: CharacterActionPlugin = {
    characterId,
    changeLocation: location ?? null,
    toolVersion: getToolVersion(),
    changeCategory,
    changeDescriptors,
  };

  return {
    messageName: CHARACTER_ACTION_MESSAGE_NAME,
    platform: getPlatform(),
    plugins: [userPlugin, geoPlugin, viewPlugin, characterActionPlugin],
  };
};
